import { render } from "./BulkDatabaseTaskTable.vue?vue&type=template&id=23ce8328&scoped=true&ts=true"
import script from "./BulkDatabaseTaskTable.vue?vue&type=script&lang=ts"
export * from "./BulkDatabaseTaskTable.vue?vue&type=script&lang=ts"

import "./BulkDatabaseTaskTable.vue?vue&type=style&index=0&id=23ce8328&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ce8328"]])

export default __exports__